import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * When we get error on sending confirmation email
 */
export class CantSendConfirmationEmail extends NoticeBase
{
	constructor(errorCode: string = '')
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_CANT_SEND_CONFIRMATION_EMAIL'),
			Loc.getMessage('EXT_B24NET_LOGGING_IN_SOMETHING_WENT_WRONG'),
			errorCode,
		);
	}
}
